// extracted by mini-css-extract-plugin
module.exports = {"twoFactorWarningContainer":"Warning2FA_twoFactorWarningContainer__1o2C4"};